export default __webpack_public_path__ + "static/media/Apple MacBook Pro 15-inch.4a510516.png";